<template>
    <transition name="fade">
        <div
            v-if="!uiHidden || exhibitionMode.enabled"
            class="absolute left-0 right-0 z-10 mx-auto w-full max-w-[500px] px-3"
            :class="{ onAudiobookView: isAudiobook, exhibitionMode: exhibitionMode.enabled && onlyDesktopVisible }"
            :style="positionTop"
        >
            <div v-if="exhibitionMode.enabled && onlyDesktopVisible">
                <div class="QrShare-container ml-auto p-5">
                    <p class="mb-3">{{ exhibitionMode.label }}</p>
                    <div class="QrShare-border relative flex justify-center">
                        <iframe :src="iframeUrl" :title="localizations[lang].share.qrCodeTitle"></iframe>
                    </div>
                </div>
            </div>
            <div v-else class="rounded-2xl bg-theme-bg p-6 shadow-lg">
                <div v-if="isBuyable" class="flex items-center justify-between">
                    <p class="m-0 text-lg text-theme-text">
                        {{ localizations[lang].buyNowText }}
                    </p>
                    <button
                        type="button"
                        class="rounded-lg bg-theme-buynow-bg px-8 py-3 font-medium text-theme-buynow-text hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        data-cy="buyNowButton"
                        @click="togglePaymentLinks"
                    >
                        {{ buyNowButtonText }}
                    </button>
                </div>

                <div v-if="userIsGuest" class="text-center">
                    <div v-if="isBuyable" class="my-4 border-t border-theme-border"></div>
                    <div class="flex items-center justify-center gap-2">
                        <span class="text-theme-toolbar-icon">{{ localizations[lang].alreadyPurchased }}</span>
                        <button
                            class="rounded font-medium text-theme-icon hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                            @click="openLoginForm"
                        >
                            {{ localizations[lang].logIn }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { uiAPI } from '../../../src/js/communication';

export default {
    computed: {
        ...mapState([
            'ui',
            'uiHidden',
            'isOffline',
            'localizations',
            'lang',
            'isBuyableButtonText',
            'isBuyable',
            'userIsGuest',
            'issue',
            'exhibitionMode',
        ]),
        ...mapGetters(['onlyMobileVisible', 'isAudiobook', 'onlyDesktopVisible']),
        positionTop() {
            let top = 10;
            if (this.isOffline) {
                top = this.onlyMobileVisible ? 65 : 45;
            }

            return `top: ${this.ui.headerbar.offsetHeight + top}px`;
        },
        buyNowButtonText() {
            return this.isBuyableButtonText || this.localizations[this.lang].buyNow;
        },
        iframeUrl() {
            const shareUrl = new URL(this.issue.share_url);
            shareUrl.searchParams.set('utm_source', 'reader');
            shareUrl.searchParams.set('utm_medium', 'qr-purchase');
            shareUrl.searchParams.set('utm_campaign', 'exhibition-mode');

            return encodeURI(
                `https://makeaqr.publica.la/?url=${encodeURIComponent(shareUrl.toString())}&show_action_buttons=false&max_width=175`
            );
        },
    },
    methods: {
        togglePaymentLinks() {
            uiAPI.togglePaymentLinks();
        },
        openLoginForm() {
            uiAPI.openLoginForm();
        },
    },
};
</script>
